import { createSelector } from '@reduxjs/toolkit';
import { GroupEntity, GroupMemberTotalsEntity } from '@interpals/api-web';

import { ReduxState } from 'redux/root-reducer';
import { GroupMembersState } from 'redux/group/reducer';

const selectGroupState = (state: ReduxState) => state.group;

export const selectGroup = createSelector(selectGroupState, (group): GroupEntity | null => group?.group);

export const selectGroupMembers = createSelector(selectGroupState, (state): GroupMembersState => state.members);

export const selectGroupMemberTotals = createSelector(
    selectGroupState,
    (state): GroupMemberTotalsEntity | undefined => state.members.totals,
);
